//状态，不允许直接对state操作，只能通过mutations或者actions改变
const state = {
    keepList:['a']
}


//同步方法
const mutations = {
    setKeepList (state) {
        state.keepList = ['a','custome']
    },
    removeKeepList(state){
        state.keepList = ['a']
    }
}

//异步方法
const actions = {
    setKeepListAction( {commit} ){
        commit('setKeepList')
    },
    removeKeepListAction( {commit} ){
        commit('removeKeepList')
    }
}
export default{
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/keep.js